module.exports = __webpack_public_path__ + "static/media/Manufacture.78d973e1.xlsx";